module.exports = __webpack_public_path__ + "static/eduardo-8c824d8c8fae9e341add346dcad1b78a.png";